import { render, staticRenderFns } from "./foodsuggestion.vue?vue&type=template&id=5dc2c03d"
import script from "./foodsuggestion.vue?vue&type=script&lang=js"
export * from "./foodsuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports